<template>
  <ThemeDefaultLayoutPage
    :title="asyncCategory?.section.title"
    :description="asyncCategory?.section.description"
    :breadcrumbs="breadcrumbs"
    :show-category="false"
    custom-padding="lg:!tw-py-11 !tw-py-6"
  >
    <template v-if="promotions.length > 0">
      <div
        class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 lg:tw-gap-8 tw-gap-4 tw-mt-2 md:tw-mt-4 tw-mb-4"
      >
        <div
          v-for="item in promotions"
          :key="item._id"
        >
          <ThemeDefaultCardPromotion
            title-tag="h2"
            :image="item.imageCover || ''"
            :title="item.title || ''"
            :description="item.description || ''"
            :recommended="item.recommended"
            :path="getPath({ componentName: 'Promotion', slug: item.slug || ''})"
            @click="eventPromotion(item.title)"
          />
        </div>
      </div>
      <Pagination
        v-model="page"
        :per-page="perPage"
        :total="total"
        class="tw-flex tw-justify-center"
      />
    </template>
    <LandingNoData v-else />
  </ThemeDefaultLayoutPage>
</template>

<script setup lang="ts">
const {
  asyncCategory,
  breadcrumbs,
  promotions,
  page,
  perPage,
  total,
  getPath,
  eventPromotion,
} = await usePromotionPage()
</script>
